import "core-js/modules/es.array.for-each";
import "core-js/modules/web.dom-collections.for-each";
import { env } from '../../services/env';
var context = {
  router: null,

  get route() {
    return this.router.currentRoute;
  }

};
var trackerFn = null;

/**
 * 初始化埋点配置
 *
 * @export
 * @param {IConfig} config
 */
export function initTrack(config) {
  var router = config.router,
      tracker = config.tracker;
  context.router = router;
  trackerFn = tracker;
}
export function createWindTrack(trackerList) {
  var obj = Object.create(null);
  Object.keys(trackerList).forEach(function (k) {
    obj[k] = function (arg) {
      if (env.isBrowser) {
        if (process.env.NODE_ENV === 'devlomplent' && (!trackerFn || !context.router)) {
          throw new Error('埋点前，请先执行 initTrack 方法进行初始化');
        }

        var _data = trackerList[k].call(context, arg);

        trackerFn(_data);
      }
    };
  });
  return obj;
}